// Refusals arrive as `{ data: { error_code, message } }`; validation errors don't
// carry a readable message.
export function apiErrorDetail(error: unknown): string | null {
  if (!error || typeof error !== 'object' || !('data' in error)) return null;
  const data = error.data;
  if (
    data &&
    typeof data === 'object' &&
    'message' in data &&
    typeof data.message === 'string'
  ) {
    return data.message;
  }
  return null;
}
